<template>
  <el-option-group>
    <el-option
      v-for="item in dataList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-option-group>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default: function () {
        return {
          except: "",
          label: "name",
          value: "id",
          dataList: [],
        };
      },
    },
  },
  computed: {
    dataList() {
      let label = this.dataInfo.label;
      let value = this.dataInfo.value;

      const RollBack = (level, dataList, initData) => {
        if (dataList != null && dataList.length > 0) {
          dataList.forEach((element) => {
            let isTrue = this.dataInfo.except == element[value];
            if (!isTrue) {
              let separ = "";
              for (let index = 1; index < level; index++) {
                separ = separ + "|——";
              }
              initData.push({
                id: element[value],
                name: separ + " " + element[label],
              });
              if (element.children != null && element.children.length > 0) {
                RollBack(level + 1, element.children, initData);
              }
            }
          });
        }
      };

      let level = 1;
      let initData = [];
      let dataList = this.dataInfo.dataList;

      if (dataList != null && dataList.length > 0) {
        RollBack(level, dataList, initData);
      }
      return initData;
    },
  },
};
</script>